export const API = window.env ? window.env.API_URL_PUB : ((process.env.API_URL_INT) || process.env.API_URL_PUB || __URL__);
